import Vue from 'vue';
import Vuex from 'vuex';
import loader, {LOADER_NAMESPACE} from './modules/loader';
import flights, {FLIGHTS_NAMESPACE} from './modules/flights';
import services, {SERVICES_NAMESPACE} from './modules/services';
import routes, {ROUTES_NAMESPACE} from './modules/routes';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        [LOADER_NAMESPACE]: loader,
        [FLIGHTS_NAMESPACE]: flights,
        [SERVICES_NAMESPACE]: services,
        [ROUTES_NAMESPACE]: routes
    }
});